import { useContext } from 'react';
import { MeetingDrawerContext } from '../contexts/MeetingDrawerContext';

export const useMeetingDrawer = () => {
  const context = useContext(MeetingDrawerContext);
  if (context === undefined) {
    throw new Error('useMeetingDrawer must be used within a MeetingDrawerProvider');
  }
  return context;
};
